import { actions } from "components/settings/user/form/logic/actions";
import { ACTION_STATES } from "core/actions";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import UserForm from "./userForm";
import { Container } from "@mui/material";

function Form() {
    let { id } = useParams();

    const dispatch = useDispatch();
    const formStatus = useSelector((state) => state.userForm.formStatus);
    const navigate = useNavigate();

    useEffect(() => {
        dispatch(actions.LOAD_USER.send(id));

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    function handleCancel() {
        navigate(-1);
    }

    if (formStatus === ACTION_STATES.SUCCESS) {
        return (
            <Container maxWidth={"xl"} className={"atsGlobalContainer"}>
                <UserForm isNew={id == -1} onCancel={handleCancel} />
            </Container>
        );
    }

    return <div>Loading...</div>;
}

export default Form;
